import { MasterDataRepoImpl } from "domain/repository/MasterData/MasterDataRepoImpl";
import { StandardTariffCodeRepoImpl } from "domain/repository/TariffCode/StandardTariffCodeRepoImpl";
import { TariffCodeComponentRepoImpl } from "domain/repository/TariffCode/TariffCodeComponentRepoImpl";
import { TariffComponentRepoImpl } from "domain/repository/TariffCode/TariffComponentRepoImpl";
import { TariffComponentValueRepoImpl } from "domain/repository/TariffCode/TariffComponentValueRepoImpl";
import { TariffTypeRepoImpl } from "domain/repository/TariffCode/TariffTypeRepoImpl";
import { useTariffCodeTracked } from "presentation/store/TariffCode/TariffCodeProvider";
import { TariffCodeVM } from "presentation/viewModel/TariffCode/TariffCodeVM";
import { useMemo } from "react";

export const useTariffCodeVM = () => {
    const [, setTariffCodeState] = useTariffCodeTracked();
    const tariffCodeVM = useMemo(() =>
        TariffCodeVM({
            dispatch: [setTariffCodeState],
            tariffTypeRepo: TariffTypeRepoImpl(),
            standardTariffCodeRepo:StandardTariffCodeRepoImpl(),
            tariffComponentRepo: TariffComponentRepoImpl(),
            tariffComponentValueRepo: TariffComponentValueRepoImpl(),
            tariffCodeComponentRepo: TariffCodeComponentRepoImpl(),
            masterDataRepo: MasterDataRepoImpl(),
        }), [setTariffCodeState])

    return tariffCodeVM
}

